/* eslint @typescript-eslint/naming-convention: 0 */
import type { Currency } from '@/wabunka-src/common/utils/googleAnalytics/googleAnalytics';
import type { WabunkaExperienceEventViewModel } from '@/wabunka-src/features/Experience/models/experienceEvent';

export interface ItemParams {
  item_id: string;
  item_name: string;
  price: number;
  tax: number;
  currency: Currency;
  item_brand: string | undefined;
  quantity: number;
}

export const buildWabunkaItemParamsByExperienceEvent = (experienceEvent: WabunkaExperienceEventViewModel, quantity: number = 1): ItemParams => {
  return {
    item_id: experienceEvent.experience.slug,
    item_name: experienceEvent.experience.name,
    price: experienceEvent.price,
    tax: Math.floor((experienceEvent.price * experienceEvent.taxRate) / 100),
    currency: 'JPY',
    item_brand: experienceEvent.experience.provider?.name,
    quantity,
  };
};
